import React from "react";
import PowerOff from "material-ui/svg-icons/action/power-settings-new";
import { translate } from "react-i18next";

import api from "../api";
import MenuItem from "./MenuItem";

const NavigationMenu = ({
  items, history, closeDrawer, t,
}) => (
  <div
    style={{ display: "flex", flexDirection: "column", height: "100%" }}
    className="navigation_menu"
  >
    <div style={{ marginTop: 64 }} />
    {items.map(item => <MenuItem onClick={closeDrawer} history={history} item={item} root />)}
    <div style={{ flex: 1 }} />
    <MenuItem
      style={{
        borderWidth: "1px 0 0 0",
      }}
      root
      onClick={() => api.authLogout()}
      item={{
        name: t("Выйти"),
        rightIcon: <PowerOff />,
      }}
    >
      {t("Выйти")}
    </MenuItem>
  </div>
);
export default translate()(NavigationMenu);



// WEBPACK FOOTER //
// ./src/components/NavigationMenu.js